'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _scroll = require('redux/modules/scroll');

var scrollActions = _interopRequireWildcard(_scroll);

var _Section = require('./Section/Section');

var _Section2 = _interopRequireDefault(_Section);

var _CircleAnimation = require('./CircleAnimation/CircleAnimation');

var _CircleAnimation2 = _interopRequireDefault(_CircleAnimation);

require('./instructions.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        positionScroll: state.scroll.positionScroll
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)(scrollActions, dispatch);
};

var Instructions = function Instructions(props) {
    var Instructions = props.strings.Instructions;

    return _react2.default.createElement(
        'div',
        { className: 'instructionsContainer' },
        _react2.default.createElement(
            'div',
            { className: 'instructionsContainer__dates' },
            Instructions.texts.map(function (dataInstructions, index) {
                return _react2.default.createElement(_Section2.default, { key: "instructionsContainer-" + index, date: dataInstructions.date, text: dataInstructions.text });
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'instructionsContainer__animation' },
            _react2.default.createElement(
                'div',
                { className: 'instructionsContainer__animation__firstRow' },
                _react2.default.createElement(_CircleAnimation2.default, { order: 'first' }),
                _react2.default.createElement('div', { className: 'instructionsContainer__animation__firstRow__bar' }),
                _react2.default.createElement(_CircleAnimation2.default, { order: 'second' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'instructionsContainer__animation__hand' },
                _react2.default.createElement('i', { className: 'icon-hand' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'instructionsContainer__animation__secondRow' },
                Instructions.instructions
            )
        ),
        _react2.default.createElement('button', { className: 'cover__container__button icon-arrow', onClick: function onClick() {
                props.setPositionScroll(2);
                props.setCarouselScroll(2);
            } })
    );
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Instructions);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructions/Instructions.js
// module id = 698
// module chunks = 0